export const getAccessTokenCookie = () => {
  if (typeof document === "undefined") {
    return null;
  }

  const match = document.cookie.match(/(?:^|; )accessToken=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
};

const VIEWER_ACCESS_TOKEN_KEY = "viewerAccessToken";
const VIEWER_USER_DATA_KEY = "viewerUserData";
const VIEWER_EXPERIENCE_ID_KEY = "viewerExperienceId";

const getSessionStorage = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.sessionStorage;
};

export const getViewerAccessToken = () => {
  const storage = getSessionStorage();
  return storage?.getItem(VIEWER_ACCESS_TOKEN_KEY) || null;
};

export const getViewerExperienceId = () => {
  const storage = getSessionStorage();
  return storage?.getItem(VIEWER_EXPERIENCE_ID_KEY) || null;
};

export const getViewerUserData = () => {
  const storage = getSessionStorage();
  const rawValue = storage?.getItem(VIEWER_USER_DATA_KEY);

  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    console.error("Failed to parse viewer user data from session storage", error);
    return null;
  }
};

export const setViewerSession = ({
  viewerAccessToken,
  userData,
  experienceId,
}) => {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  if (viewerAccessToken) {
    storage.setItem(VIEWER_ACCESS_TOKEN_KEY, viewerAccessToken);
  }

  if (experienceId) {
    storage.setItem(VIEWER_EXPERIENCE_ID_KEY, experienceId);
  }

  if (userData) {
    storage.setItem(VIEWER_USER_DATA_KEY, JSON.stringify(userData));
  }
};

export const clearViewerSession = () => {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(VIEWER_ACCESS_TOKEN_KEY);
  storage.removeItem(VIEWER_USER_DATA_KEY);
  storage.removeItem(VIEWER_EXPERIENCE_ID_KEY);
};
